'use client';

import React, { JSX, useState } from 'react';
import Image from '@/components/image/Image';
import IsoModal from '@/components/IsoModal';
import { ApiImage } from '../../../api/model';
import { AspectRatio } from '@/Util/imageLoader';
import { Props } from '@/types/cms/magnolia';

const MapModal = ({
  map,
  aspectRatio,
  pageProps
}: {
  map: ApiImage;
  aspectRatio: AspectRatio;
  pageProps?: Props;
}): JSX.Element => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <div className="introduction__map__image" onClick={(): void => setModalOpen(true)}>
        <Image
          image={map}
          width={256}
          height={256}
          aspectRatio={aspectRatio}
          serverSideContext={pageProps?.albConfig.context}
          isMapImage
          pageProps={pageProps}
        />
      </div>
      {!!map && (
        <IsoModal
          className="introduction__modal"
          toggle={(): void => setModalOpen(value => !value)}
          isOpen={modalOpen}
          onClose={(): void => setModalOpen(false)}
        >
          <Image
            image={map}
            useDefaultLoader
            serverSideContext={pageProps?.albConfig.context}
            isMapImage
            pageProps={pageProps}
          />
        </IsoModal>
      )}
    </>
  );
};

export default MapModal;
